import styles from "./DifferentStaffModalContent.module.scss"

import { useEvent } from "@/public/event"
import { convertDateToHumanReadableJstDateStr } from "@/utils/date"

export type DifferentStaffModalContentStaff = {
	scrapingTargetSiteId: string
	name: string
}

type Props = {
	treatableAvailableStaffs: DifferentStaffModalContentStaff[]
	onClick: (selectedStaffId: string, staffName: string) => void
	onCancel: () => void
	startTime: Date | undefined
	originStaffId?: string
}

const DifferentStaffModalContent = ({
	treatableAvailableStaffs,
	onClick,
	onCancel,
	startTime,
	originStaffId,
}: Props) => {
	const event = useEvent()

	if (treatableAvailableStaffs.length === 0) {
		return (
			<div className={styles.container}>
				<div className={styles.header}>
					<h3>エラー</h3>
					<p>選択可能なスタッフがいません。</p>
				</div>
				<div className={styles.actions}>
					<button type="button" className={styles.cancel_button}>
						閉じる
					</button>
				</div>
			</div>
		)
	}

	return (
		<div className={styles.container}>
			<button className={styles.close_button} onClick={onCancel}>
				×
			</button>
			<h3>前回ご指名のスタッフは枠が埋まっております</h3>
			<div className={styles.header}>
				<p>
					前回指名のスタッフは枠が埋まっておりました。
					<br />
					代わりに別のスタッフでご予約はいかがでしょうか？
				</p>
			</div>
			<div className={styles.time_info}>
				<div className={styles.time_info_label}>選択中の日時</div>
				<p className={styles.time_info_value}>
					{startTime ? convertDateToHumanReadableJstDateStr(startTime) : ""}
				</p>
			</div>
			<div className={styles.staff_list}>
				{treatableAvailableStaffs.map((staff) => (
					<div
						key={staff.scrapingTargetSiteId}
						className={styles.staff_option}
						onClick={() => {
							onClick(staff.scrapingTargetSiteId, staff.name)
							event.clickDifferentStaffInDifferentStaffsPopup(
								originStaffId ?? "",
								staff.scrapingTargetSiteId
							)
						}}
					>
						<div className={styles.staff_name}>{staff.name}</div>
					</div>
				))}
			</div>
			<div className={styles.note_wrapper}>
				<p className={styles.note_text}>※ 別途指名料がかかる場合がございます</p>
				<p className={styles.note_text}>
					※ 本画面の予約はホットペッパー予約ではありません
				</p>
			</div>
		</div>
	)
}

export default DifferentStaffModalContent
